import { axiosObject } from "../auctionServiceConfig";

export function getAuctionEventByUuidForAdmin(id: any) {
  return new Promise((resolve, reject) => {
    let uri = "/data/resource/events/_read";
    let payload = {
      apiConfig: {
        includeRelations: "*",
        includeMutations: "*",
      },
      limitBy: {
        per_page: 10,
        page: 1,
      },
      sortBy: [],
      filterBy: [
        {
          attribute: "uuid",
          op: "eq",
          value: id,
        },
      ],
    };

    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data.data[0]);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

export function getEventsExport() {
  return new Promise((resolve, reject) => {
    let uri = "/export-events";

    axiosObject
      .get(uri)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

export function runTypesenseIndexing() {
  return new Promise((resolve, reject) => {
    let uri = "/run-typesense-indexing";

    axiosObject
      .post(uri)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

export function getLatestBidForAdmin(event_uuid: any) {
  return new Promise((resolve, reject) => {
    let uri = `/data/resource/bids/_read`;
    let payload = {
      apiConfig: {
        includeRelations: "*",
        includeMutations: "*",
      },
      limitBy: {
        per_page: 10,
        page: 1,
      },
      sortBy: [{ attribute: "created_at", order: "desc" }],
      filterBy: [
        {
          attribute: "event_uuid",
          op: "eq",
          value: event_uuid,
        },
      ],
    };

    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data.data[0]);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

export function getAllBidsForAdmin(event_uuid: any) {
  return new Promise((resolve, reject) => {
    let uri = `/data/resource/bids/_read`;
    let payload = {
      apiConfig: {
        includeRelations: "*",
        includeMutations: "*",
      },
      limitBy: {
        per_page: 999,
        page: 1,
      },
      sortBy: [{ attribute: "created_at", order: "asc" }],
      filterBy: [
        {
          attribute: "event_uuid",
          op: "eq",
          value: event_uuid,
        },
      ],
    };

    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

export function getAllWrongBidsForAdmin(event_uuid: any) {
  return new Promise((resolve, reject) => {
    let uri = `/data/resource/wrong-bids/_read`;
    let payload = {
      apiConfig: {
        includeRelations: "*",
        includeMutations: "*",
      },
      limitBy: {
        per_page: 999,
        page: 1,
      },
      sortBy: [{ attribute: "created_at", order: "asc" }],
      filterBy: [
        {
          attribute: "event_uuid",
          op: "eq",
          value: event_uuid,
        },
      ],
    };

    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

export function mailchimpSyncUsers(payload: any) {
  return new Promise((resolve, reject) => {
    let uri = "/mailchimp-sync-users";
    console.log("Log from Promise", payload);

    axiosObject
      .post(uri, payload)
      .then(async (response) => {
        console.log("log from response", response);

        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

export function uploadFile(file: any, params: any) {
  return new Promise((resolve, reject) => {
    let uri = "/data/resource/files/_create";
    let data = new FormData();
    data.append("file", file);
    axiosObject
      .post(uri, data, {
        params: params,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

export function createBulkUpload(payload: any) {
  return new Promise((resolve, reject) => {
    let uri = `/data/resource/bulkupload/_create`;
    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

export function updateBulkUpload(payload: any) {
  return new Promise((resolve, reject) => {
    let uri = `/data/resource/bulkupload/_patch`;

    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

export function getAllBulkupload(params: any) {
  return new Promise((resolve, reject) => {
    let uri = `/data/resource/bulkupload/_read`;
    let payload = {
      apiConfig: {
        includeRelations: "*",
        includeMutations: "*",
      },
      limitBy: {
        per_page: params.per_page,
        page: params.page,
      },
      sortBy: [{ attribute: "created_at", order: "desc" }],
      filterBy: [],
    };

    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

export function getBulkuploadByUuid(uuid: any) {
  return new Promise((resolve, reject) => {
    let uri = `/data/resource/bulkupload/_read`;
    let payload = {
      apiConfig: {
        includeRelations: "*",
        includeMutations: "*",
      },
      limitBy: {
        per_page: 1,
        page: 1,
      },
      sortBy: [{ attribute: "created_at", order: "desc" }],
      filterBy: [
        {
          attribute: "uuid",
          op: "eq",
          value: uuid,
        },
      ],
    };

    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data.data[0]);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

export function getAllOnboardings(params: any) {
  return new Promise((resolve, reject) => {
    let uri = "/data/resource/bidder-onboarding/_read";

    let payload: any = {};
    payload["apiConfig"] = {};
    payload["apiConfig"]["includeRelations"] = [""];

    payload["limitBy"] = {};
    payload["limitBy"]["page"] = params.page;
    payload["limitBy"]["per_page"] = params.per_page;

    payload["sortBy"] = [];
    payload["sortBy"].push({
      attribute: "created_at",
      order: "desc",
    });
    payload["filterBy"] = [];

    if (params["filters"]["email"] && params["filters"]["email"] !== "") {
      payload["filterBy"].push({
        attribute: "email",
        op: "like",
        value: params["filters"]["email"],
      });
    }
    if (params["filters"]["type"] && params["filters"]["type"] !== "") {
      payload["filterBy"].push({
        attribute: "type",
        op: "like",
        value: params["filters"]["type"],
      });
    }
    if (params["filters"]["status"] && params["filters"]["status"] !== "") {
      payload["filterBy"].push({
        attribute: "status",
        op: "like",
        value: params["filters"]["status"],
      });
    }

    axiosObject
      .post(uri, payload)
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}
export function getOnboardingByUuid(uuid: any) {
  return new Promise((resolve, reject) => {
    let uri = "/data/resource/bidder-onboarding/_read";

    let payload: any = {
      apiConfig: {
        includeRelations: "*",
        includeMutations: "*",
      },
      limitBy: {
        per_page: 10,
        page: 1,
      },
      sortBy: [],
      filterBy: [
        {
          attribute: "uuid",
          op: "eq",
          value: uuid,
        },
      ],
    };

    axiosObject
      .post(uri, payload)
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}
export function getOnboardingByUserUuid(uuid: any) {
  return new Promise((resolve, reject) => {
    let uri = "/data/resource/bidder-onboarding/_read";

    let payload: any = {
      apiConfig: {
        includeRelations: "*",
        includeMutations: "*",
      },
      limitBy: {
        per_page: 10,
        page: 1,
      },
      sortBy: [],
      filterBy: [
        {
          attribute: "user_uuid",
          op: "eq",
          value: uuid,
        },
      ],
    };

    axiosObject
      .post(uri, payload)
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}
export function updateOnboardingForAdmin(
  payload: any,
  uuid: any,
  user_uuid: any
) {
  return new Promise((resolve, reject) => {
    let uri = "/data/resource/bidder-onboarding/_patch";
    const data = JSON.parse(JSON.stringify(payload));
    data["type"] = data.type.value;
    data["preferred_location"] = JSON.stringify(data.preferred_location);
    data["preferred_property_type"] = JSON.stringify(
      data.preferred_property_type
    );
    data["price_range"] = data.price_range.value;
    data["uuid"] = uuid;
    data["user_uuid"] = user_uuid;

    console.log("payload::>", data);
    axiosObject
      .post(uri, data)
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}
